import React, { FC, useCallback, useEffect } from 'react';
import { LayoutWrapper } from 'components/LayoutWrapper';
import { useLocation } from 'react-router-dom';
import { ActionNotification } from './components/ActionNotification';
import { SkeletonDeploymentGroup } from './components/Skeleton';
import { StatusView } from './components/StatusView';
import { selectEmail } from './preferencesSelectors';
import { initUserPreferences, unsubscribeAll } from './preferencesSlice';
import { ActionsBar } from './scenes/ActionBar';
import { PreferenceGroup } from './scenes/PreferenceGroup';
import { trackUnsubscribeAllClick } from './services/userActionEvents';
import { ConsentDeclinePrDialog } from './scenes/ConsentDeclinePrDialog';
import { ConsentDialog } from './scenes/ConsentDialog';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { GlobalUnsubscribeDialog } from './scenes/GlobalUnsubscribeDialog';
import { DoubleOptInDialog } from './scenes/DoubleOptInDialog';
import { useFeatureFlags } from '../../components/FeatureFlagProvider/FeatureFlagProvider';

const PreferencesCenter: FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const email = useAppSelector(selectEmail);
  const featureFlags = useFeatureFlags();

  useEffect(() => {
    dispatch(initUserPreferences({ query: location.search, useSso: featureFlags['pc-frontend-use-sso'] }));
  }, [dispatch, location, featureFlags]);

  const unsubscribeHandler = useCallback(() => {
    trackUnsubscribeAllClick();
    dispatch(unsubscribeAll());
  }, [dispatch]);

  const actionBarHandler = useCallback(
    () => (email == null ? null : <ActionsBar email={email} onUnsubscribeClick={unsubscribeHandler} />),
    [email, unsubscribeHandler],
  );

  return (
    <LayoutWrapper headerContent={actionBarHandler}>
      <div>
        <ActionNotification />
        <SkeletonDeploymentGroup />
        <PreferenceGroup />
        <StatusView />
        <ConsentDialog />
        <ConsentDeclinePrDialog />
        <GlobalUnsubscribeDialog onUnsubscribeClick={unsubscribeHandler} />
        <DoubleOptInDialog />
      </div>
    </LayoutWrapper>
  );
};

export default PreferencesCenter;
